import { PartialTranslation } from '../translations';

export const gu: PartialTranslation = {
  newChat: 'નવી ચેટ',
  search: 'શોધો',
  user: 'વપરાશકર્તા',
  settings: 'સેટિંગ્સ',
  language: 'ભાષા',
  getHelp: 'મદદ મેળવો',
  viewAllPlans: 'બધી યોજનાઓ જુઓ',
  learnMore: 'વધુ શીખો',
  logOut: 'લૉગ આઉટ',
  chooseLanguage: 'ભાષા પસંદ કરો',
  chooseYourPreferredLanguage: 'તમારી પસંદીદા ભાષા પસંદ કરો',
  searchLanguages: 'ભાષાઓ શોધો...',
  autoDetect: 'આપોઆપ શોધ',
  noLanguagesFound: 'કોઈ ભાષાઓ મળી નથી',
  askAnything: 'કંઈપણ પૂછો',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'વ્યક્તિગત',
  freePlan: 'મફત યોજના',
  current: 'વર્તમાન',
  close: 'બંધ કરો',
  archive: 'આર્કાઇવ',
  delete: 'કાઢી નાખો',
  confirmDelete: 'શું તમે ખરેખર આ વાતચીત કાઢી નાખવા માંગો છો?',
  confirmArchive: 'શું તમે ખરેખર આ વાતચીતને આર્કાઇવ કરવા માંગો છો?',
  deleteCannotUndo: 'આ ક્રિયા પૂર્વવત્ કરી શકાતી નથી.',
  archiveCanFind: 'આર્કાઇવ કર્યા પછી તમે તેને આર્કાઇવ સૂચીમાં શોધી શકશો.',
  // 资源面板
  resources: 'સંસાધનો',
  addResource: 'સંસાધન ઉમેરો',
  deleteResource: 'સંસાધન કાઢી નાખો',
  noMatchingResourcesFound: 'કોઈ મેળ ખાતા સંસાધન મળ્યા નથી',
  noResourcesAvailable: 'કોઈ સંસાધન ઉપલબ્ધ નથી',
  hideResources: 'સંસાધન છુપાવો',
  showResources: 'સંસાધન બતાવો',
  
  // 聊天输入框
  typeMessage: 'સંદેશ લખો...',
  thinkingOptions: 'વિચારવાના વિકલ્પો',
  deleteFile: 'ફાઇલ કાઢી નાખો',
  clearSelection: 'પસંદગી સાફ કરો',
  
  // 思考模式选项
  deepInsight: 'ઊંડી સમજ · સપાટી વિશ્લેષણ',
  deepInsightDesc: 'મુખ્ય મુદ્દાઓની ઝડપી સમજ',
  deepExploration: 'ઊંડી શોધ · વ્યાપક વિશ્લેષણ',
  deepExplorationDesc: 'બહુવિધ પરિમાણીય ઊંડા સંશોધન',
  deepDeconstruction: 'ઊંડો ડિકન્સ્ટ્રક્શન · પદ્ધતિસરની દલીલ',
  deepDeconstructionDesc: 'સ્તર દ્વારા સ્તરીય પ્રગતિશીલ વિશ્લેષણ',
  
  // 写作模式选项
  contractReview: 'કોન્ટ્રાક્ટ સમીક્ષા · જોખમ ઓળખ',
  contractReviewDesc: 'કલમ વિશ્લેષણ અનુપાલન તપાસ',
  textPolish: 'ટેક્સ્ટ પોલિશ · વ્યાવસાયિક અભિવ્યક્તિ',
  textPolishDesc: 'ભાષા ઑપ્ટિમાઇઝેશન અને માળખાકીય ગોઠવણ',
  legalDocuments: 'કાનૂની દસ્તાવેજો · માનક ડ્રાફ્ટિંગ',
  legalDocumentsDesc: 'વ્યાવસાયિક કાનૂની દસ્તાવેજ લેખન',
  addAttachment: 'જોડાણ ઉમેરો',
  sendMessage: 'સંદેશ મોકલો',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'લૉગ ઇન',
  register: 'નોંધણી કરો',
  welcomeBack: 'LawHelper માં આપનું સ્વાગત છે',
  loginSubtitle: 'તમારો AI કાનૂની સંશોધન સહાયક',
  continueWithGoogle: 'Google સાથે ચાલુ રાખો',
  continueWithMicrosoft: 'Microsoft સાથે ચાલુ રાખો',
  continueWithWeChat: 'WeChat સાથે ચાલુ રાખો',
  orContinueWith: 'અથવા આની સાથે ચાલુ રાખો',
  emailTab: 'ઈમેઇલ',
  phoneTab: 'ફોન',
  emailPlaceholder: 'તમારો ઈમેઇલ દાખલ કરો',
  phonePlaceholder: 'ફોન નંબર દાખલ કરો',
  codePlaceholder: '6 અંકનો કોડ દાખલ કરો',
  sending: 'મોકલી રહ્યા છીએ...',
  verifying: 'ચકાસી રહ્યા છીએ...',
  verify: 'ચકાસો',
  sendMagicLink: 'મેજિક લિંક મોકલો',
  getVerificationCode: 'કોડ મેળવો',
  resendCode: 'કોડ ફરીથી મોકલો',
  resendIn: 'ફરીથી મોકલો',
  magicLinkSent: 'મેજિક લિંક તમારા ઈમેઇલ પર મોકલવામાં આવી',
  magicLinkHint: 'અમે તમારા ઈમેઇલ પર એક સુરક્ષિત લિંક મોકલીશું',
  otpSent: 'ચકાસણી કોડ મોકલવામાં આવ્યો',
  agreeToTerms: 'ચાલુ રાખીને, તમે સંમત થાઓ છો',
  privacyPolicy: 'ગોપનીયતા નીતિ',
  termsOfService: 'સેવાની શરતો',
  and: 'અને',
  privacyTitle: 'તમારી ગોપનીયતા મહત્વપૂર્ણ છે',
  privacyIntro: 'અમે તમને શ્રેષ્ઠ અનુભવ પ્રદાન કરવા કૂકીઝ અને સમાન ટેક્નોલોજીનો ઉપયોગ કરીએ છીએ.',
  essentialCookies: 'આવશ્યક કૂકીઝ',
  essentialDesc: 'વેબસાઇટ કાર્ય કરવા માટે જરૂરી',
  analyticsCookies: 'વિશ્લેષણ કૂકીઝ',
  analyticsDesc: 'સેવા સુધારવામાં મદદ કરે છે',
  marketingCookies: 'માર્કેટિંગ કૂકીઝ',
  marketingDesc: 'વ્યક્તિગત સામગ્રી માટે વપરાય છે',
  acceptAll: 'બધું સ્વીકારો',
  essentialOnly: 'ફક્ત આવશ્યક',
  customize: 'કસ્ટમાઇઝ કરો',
  savePreferences: 'પસંદગીઓ સાચવો',
  back: 'પાછળ',
  readPrivacyPolicy: 'અમારી ગોપનીયતા નીતિ વાંચો',
  cookiePolicy: 'કૂકી નીતિ',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI સમીક્ષા',
  aiDraft: 'AI ડ્રાફ્ટ',
  smartAssistant: 'નમૂનો',

  // 知识库搜索
  enableKnowledgeSearch: 'શોધ સક્ષમ કરો',
  knowledgeSearchDesc: 'AI તમારા દસ્તાવેજોમાં શોધે છે',
  clickToDisable: 'અક્ષમ કરો',
  clickToEnable: 'સક્ષમ કરો',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'ભાષા જવાબ',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'રદ કરો',
  library: 'પુસ્તકાલય',
  filterAll: 'બધા',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'વિચારી રહ્યા છે...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'સામાન્ય',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'વિશે',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'સ્માર્ટ દસ્તાવેજ સહાયક',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'ત્રુટિ',
  unknownError: 'Unknown error',
  file: 'ફાઇલ',
  loading: 'લોડ થઈ રહ્યું છે...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI વિશ્લેષણ',
};
